var _mask, _mask2, _mask3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentPaypal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 36 22",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 .065h9.023v10.431h-9.023z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.002.013h7.538v8.714h-7.538z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.026.079h1.981v.171h-1.981z",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 21.5,
    rx: 3,
    stroke: "#c7c7c7",
    strokeWidth: 0.5,
    width: 35.5,
    x: 0.25,
    y: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.543 10.496h-2.143c-.327-.001-.436-.109-.388-.438.138-.939.291-1.876.439-2.814l.717-4.561c.11-.704.217-1.408.335-2.11.056-.336.263-.5.609-.501 1.236-.002 2.474-.017 3.711.006.635.011 1.267.088 1.864.345.933.403 1.463 1.344 1.31 2.348-.015.098-.018.197-.027.296.021.064.063.138-.061.138-.1-.138-.24-.21-.4-.255-.37-.106-.747-.18-1.134-.182-1.014-.004-2.03-.002-3.044 0-.381 0-.5.096-.56.462-.187 1.145-.36 2.292-.545 3.437-.008.047 0 .092.002.138-.233 1.12-.364 2.256-.56 3.382-.02.11-.017.233-.125.309",
    fill: "#273a86",
    mask: "url(#a)",
    transform: "translate(4 5.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.143 7.441c.171-1.063.343-2.126.513-3.19.028-.173.052-.347.137-.505.083-.258.309-.276.52-.283.461-.015.923.01 1.384-.008.922-.034 1.775-.275 2.5-.877.583-.485.915-1.125 1.135-1.835.06-.196.058-.413.19-.585l.048-.145c.63.334.923.879.963 1.57.044.758-.119 1.48-.458 2.158-.555 1.111-1.519 1.592-2.705 1.719-.276.029-.552.03-.828.033-.332.003-.48.127-.532.45-.125.772-.245 1.544-.369 2.315-.049.306-.15.418-.416.468-.66-.028-1.32-.03-1.98 0-.22-.013-.26-.159-.237-.336.04-.317.09-.633.135-.95",
    fill: "#0098d7",
    mask: "url(#b)",
    transform: "translate(6.4 8.098)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.953 3.849c.275.017.606-.028.934.042.585.125.87.498.813 1.088-.09.956-.646 1.465-1.609 1.464-.743-.001-.61-.037-.735.65-.142.783.036.656-.77.666-.29.004-.307-.022-.263-.298.175-1.105.35-2.21.517-3.315.033-.215.121-.313.345-.3.237.013.476.003.768.003",
    fill: "#0098d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.892 3.849c.271.013.594-.022.914.039.629.119.935.552.824 1.18-.172.971-.648 1.373-1.634 1.374-.68 0-.582-.033-.681.572-.028.166-.055.332-.077.499-.021.164-.103.245-.275.238-.184-.007-.369.002-.553-.003-.125-.004-.185-.04-.158-.2.185-1.124.357-2.251.533-3.377.045-.286.083-.321.366-.322z",
    fill: "#273a86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.874 5.425c-.017-.258.114-.298.292-.281.053.005.108 0 .162 0 .537 0 .5-.031.421.463-.103.643-.21 1.286-.312 1.93-.012.079-.021.163-.106.188-.24.069-.488.047-.73.015-.12-.016-.077-.145-.089-.25-.263.185-.533.32-.85.33-.706.018-1.188-.42-1.176-1.124.013-.778.471-1.429 1.254-1.578.386-.074.787-.073 1.134.307",
    fill: "#0098d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.807 5.416c.008-.245.148-.29.343-.273.13.012.262.008.392.001.173-.009.214.078.19.23-.113.703-.228 1.407-.334 2.111-.03.195-.12.286-.32.267-.108-.01-.216-.005-.324-.002-.184.007-.365.015-.248-.307-.394.302-.776.434-1.222.347-.455-.088-.73-.37-.81-.803-.212-1.141.746-2.124 1.884-1.853.178.042.32.131.449.282m2.64 1.193c.302-.442.584-.843.852-1.253.098-.151.21-.232.395-.213.121.012.245 0 .368.003.09.002.198-.03.255.064.061.1-.033.172-.082.243-.528.763-1.058 1.525-1.589 2.287-.18.258-.364.513-.537.776-.067.102-.144.142-.265.137-.184-.01-.37-.002-.554-.003-.06 0-.126.015-.165-.052-.046-.078.014-.13.052-.184.18-.257.358-.517.549-.767.084-.11.097-.2.05-.332-.218-.612-.423-1.23-.633-1.844-.097-.286-.071-.328.222-.325.733.008.608-.098.817.603.08.27.166.538.265.86",
    fill: "#273a86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.315 7.76c-.06 0-.122-.002-.184 0-.188.007-.253-.057-.218-.264.186-1.11.361-2.22.526-3.334.034-.23.103-.352.357-.316.128.018.26.003.391.003.142 0 .189.066.166.205-.127.786-.25 1.573-.375 2.359-.049.31-.097.62-.15.93-.074.418-.076.417-.513.417",
    fill: "#0099d7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m.026.25c.041-.106.097-.091.15-.091h1.68c.054 0 .11-.015.15.09l-1.979.001",
    fill: "#0096d4",
    mask: "url(#c)",
    transform: "translate(6.618 16.716)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.922 3.256c-.288 1.781-1.317 2.933-3.018 3.27-.722.144-1.451.092-2.178.1-.211.003-.392.056-.533.219-.112-.14-.007-.284.013-.416.157-1.08.332-2.158.501-3.236.049-.308.216-.452.532-.452 1.077 0 2.154-.007 3.23.006.43.005.85.097 1.256.246.122.045.226.105.197.263",
    fill: "#242d68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.912 5.66c-.046 0-.092-.003-.138.001-.135.014-.194-.016-.158-.175.051-.224.075-.454.106-.682.016-.12.075-.178.2-.17.06.005.122 0 .183.002.362.007.53.134.535.4.006.35-.192.585-.52.614-.07.006-.139.001-.208.001v.01z",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.827 5.67c-.297.012-.298.012-.255-.288.028-.196.062-.392.093-.589.01-.063.028-.142.091-.146.242-.014.502-.07.71.099.183.149.131.359.073.553-.074.25-.262.342-.505.355-.07.004-.138.011-.207.017",
    fill: "#fbfbfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.986 7.09c-.351.002-.574-.199-.575-.517-.001-.415.343-.764.76-.77.343-.006.571.217.569.555-.003.415-.327.73-.754.732",
    fill: "#fdfefe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.692 6.357c-.006.424-.348.753-.776.746-.342-.005-.565-.22-.56-.54.006-.42.35-.764.767-.764.342 0 .573.226.569.558",
    fill: "#fdfdfe"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentPaypal);
export default __webpack_public_path__ + "static/media/payment-paypal.d5938c2515cd3f43886febf13c45975c.svg";
export { ForwardRef as ReactComponent };